import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import  { detectBrowserName,Decrypt,Encrypt }  from './../../pages/functions/functions';
import { LogsService } from './logs.service';
import { UserProfileService } from './user.service';
  const base = environment.api;
  import { EventosService } from './eventos.service';
  import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})

export class MantenimientosService {

  constructor(private http:HttpClient,private logsService:LogsService, 
    private userProfileService:UserProfileService,private eventosService:EventosService) { }
  get token(): string {
    return localStorage.getItem('token') || '';
  }

  get headers() {
    return {
      headers: {
        'x-token': this.token
      }
    }
  }


  getMantenimientos(){
    let data = {
      detail:'Consulta de todos los mantenimientos',
      msg:'Consulta de todos los mantenimientos',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'GET',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos`
    return this.http.get(base_url,this.headers);

  }
 
  postMantenimiento(mantenimiento:any){
    let data = {
      detail:'Creación de un mantenimiento',
      msg:'Creación de un mantenimiento',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'POST',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    this.eventosService.bitacora.fechaHoraEvento = moment()
    this.eventosService.bitacora.usuarioresponsable ='System';
    this.eventosService.bitacora.tiopevento = "5"
    this.eventosService.bitacora.month = moment().format('YYYY-MM')
    this.eventosService.bitacora.descripcionevento = `Operaciones de mantenimiento`
   this.eventosService.registrarEventos()
    let base_url  = `${base}mantenimientos`
    return this.http.post(base_url,mantenimiento,this.headers);
  }


  getMantenimientosBYID(id:any){
    let data = {
      detail:'Listado de mantenimientos',
      msg:'Listado de mantenimientos',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'GET',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos/${id}`
    return this.http.get(base_url,this.headers);

  }


  updateData(body:any,id:any){
    let data = {
      detail:'Actualizacion de mantenimiento',
      msg:'Actualizacion de mantenimiento',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'PUT',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos/${id}`
    return this.http.put(base_url,body,this.headers);
  }
  updateFiles(body:any,id:any){
    let data = {
      detail:'Carga de evidencias en mantenimientos',
      msg:'Carga de evidencias en mantenimientos',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'PUT',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos/evidencias/${id}`
    return this.http.put(base_url,body,this.headers);
  }
  updateStatus(body:any,id:any){
    let data = {
      detail:'Actualizacion de mantenimientos por estatus',
      msg:'Actualizacion de mantenimientos por estatus',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'PUT',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos/status/${id}`
    return this.http.put(base_url,body,this.headers);
  }

  getFiles(id:any){
    let data = {
      detail:'Listado de archivos de mantenimientos',
      msg:'Listado de archivos de mantenimientos',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'GET',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url  = `${base}mantenimientos/files/${id}`
    return this.http.get(base_url,this.headers);
  }

  
  getDownloadfile(id:any){
    let data = {
      detail:'Descarga de archivo de mantenimientos',
      msg:'Descarga de archivo de mantenimientos',
      user_id:this.userProfileService.usuario.id,
      register_id:'',
      consult:'',
      created_at:new Date(),
      petition:'GET',
      navegator:detectBrowserName(),
      is_login:null
    }
    this.logsService.postLogs(data);
    let base_url = `${base}mantenimientos/download/file/${id}`;
    return this.http.get(base_url,{headers:{'x-token': this.token}, responseType:'blob'});
  }

  getMantenimientosAlertas(){
    let base_url = `${base}alertasMantenimientos`;
    return this.http.get(base_url,this.headers);
  }
  getVigenciaAlertas(){
    let base_url = `${base}alertasVigenciasdeCalibracionMed`;
    return this.http.get(base_url,this.headers);
  }


  getAlarmas(){
    let base_url = `${base}alamardeError`;
    return this.http.get(base_url,this.headers);
  }

}
